import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import columnSort from '../../../utils/Admin/helpers/columnSort'
import './table.css'
import { ReportsAPIColumnNames, ReportsColumnNames } from "../../../utils/Admin/constants/distributers.constants";

const Table = ({ tableFor, tableData, setFilteredDataToDownload }) => {

  const [keys, setKeys] = useState([]);
  const [report, setReport] = useState([])
  const [duplicateReportData, setDuplicateReportData] = useState([])
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  const [sortValues, setSortValues] = useState({ name: '', order: 0 })

  const itemsPerPage = 10

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % tableData.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(report.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(report.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, report]);


  useEffect(() => {
    if (tableData.length === 0) {
      setItemOffset(0)
    }
    setSortValues([])
    setReport(tableData)
    setDuplicateReportData(tableData)
    
    if (tableFor === 'preview') {
      let objKeys = Object.keys(Object.assign({}, ...tableData));
      setKeys(objKeys);
    }

    if (tableFor === 'reports') {
      setKeys(ReportsAPIColumnNames)
    }
    handlePageClick({ selected: 0 })
    const el = document.querySelectorAll('.pagination-number')
    if (el.length !== 0) {
      el.forEach((item, index) => {
        item.classList.remove('selected')
      })
      
      el[0].firstElementChild?.click()
      el[0].classList.add('selected')
    }
  }, [tableData]);

  useEffect(() => {
    handlePageClick({selected: 0})
  }, [pageCount])
  
  
  const handleSortClick = (name, order) => {

    if (sortValues.name === name && sortValues.order === order) {
      setSortValues({ name: '', order: 0 })
      setReport(duplicateReportData)
      setFilteredDataToDownload(duplicateReportData)
    } else {
      setSortValues({ name: name, order })
      let sorted = columnSort(duplicateReportData, name, order)
      setFilteredDataToDownload(sorted)
      setReport(sorted)
    }
    
  }

  const replaceStringContent = (value) => {
    if (typeof value !== 'string') {
      return ''
    }
    return value.toUpperCase().trim().replace(' ', '_')
  } 

  const formatTableHeader = (value) => {
    const index = ReportsAPIColumnNames.indexOf(value?.toUpperCase())
    if (index !== -1) {
      return ReportsColumnNames[index]
    } else {
      return value
    }
  }

  return (
    <>
      <div className="table-responsive">
       <table className={ tableFor === 'reports' ? "table reports-table no-table-border" : "table reports-table"}>
         <thead>
           <tr className={ tableFor === 'reports' ? "reports-header-row bg-white" : "reports-header-row"}>
             {keys.map((title) => (
               <th className="pe-5 position-relative">
                 <div className="theader-title text-start pe-2">{ tableFor === 'reports' ? formatTableHeader(title) : replaceStringContent(title)}</div>
                 <div hidden={ tableFor === 'preview' } className="d-flex ">
                   <div
                     onClick={() => handleSortClick(title, 1)}
                     className={sortValues.name === title && sortValues.order === 1 ? "cursor-pointer text-black table-sort-actions table-sort-actions-one" : "opacity-05 cursor-pointer table-sort-actions table-sort-actions-one"}
                     hidden={ tableFor === 'preview' }
                   >&#9650;</div>
                   <div
                     onClick={() => handleSortClick(title, -1)}
                     className={sortValues.name === title && sortValues.order === -1 ? "cursor-pointer text-black table-sort-actions  table-sort-actions-two" : "opacity-05 cursor-pointer table-sort-actions  table-sort-actions-two"}
                     hidden={ tableFor === 'preview' }
                   >&#9660;</div>
                 </div>
               </th>
             ))}
           </tr>
         </thead>
         <tbody>
           
          { currentItems.length !== 0 ?
              currentItems.map((item) => {
             return (
               <tr className={ tableFor === 'reports' ? "table-body-row odd-striped even-white" : "table-body-row even-striped odd-white"}>
                 {keys.map((key) => {
                   return <td className="py-3 table-body-td text-start pe-3">{item[key]?.toLowerCase() || '--'}</td>;
                 })}
               </tr>
             );
            })
              : <tr className="text-center">
                <td colSpan={keys.length} className="tableNoDataFound py-5">No data found</td>
            </tr>
          }
         </tbody>
       </table>
 
     </div>
      <div className="table-pagination-container d-flex align-items-center justify-content-between mt-2">
        { currentItems.length !== 0 ?
          <p className="mb-0 fs-sm cl-custom-grey">{`${currentItems.length >= 10 ? itemOffset + 10 : currentItems.length} out of ${tableData.length}`}</p>
          : null
        }
        <ReactPaginate
          breakLabel="..."
          nextLabel=""
          onPageChange={handlePageClick}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          pageCount={pageCount}
          previousLabel=""
          renderOnZeroPageCount={null}
          className="d-flex"
          pageClassName="pagination-number cl-custom-grey fs-sm me-2 no-list-style"
          breakClassName="pagination-break cl-custom-grey fs-sm me-2 no-list-style"
          previousClassName="pagination-prev me-2 no-list-style no-link-dec cl-custom-grey"
          nextClassName="pagination-next no-list-style no-link-dec cl-custom-grey"
        />
      
      </div>
    </>
  );
};

export default Table;
